import type { ReactNode } from "react";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import MagasinDeRetraitIcon from "icons/MagasinDeRetraitIcon";
import type { TypographyProps } from "@mui/material";

interface DisplayMagasinDeRetraitProps extends Omit<TypographyProps, "sx"> {
  magasinDeRetrait: string;
  item?: boolean;
  noIcon?: boolean;
}

function DisplayMagasinDeRetrait({
  magasinDeRetrait,
  item = false,
  noIcon = false,
  ...typographyProps
}: Readonly<DisplayMagasinDeRetraitProps>): ReactNode {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <Grid container size={item ? "grow" : undefined} sx={{ gap: 1, alignItems: "center" }}>
      {!noIcon && (
        <Grid container size="auto">
          <MagasinDeRetraitIcon fontSize="small" color="primary" />
        </Grid>
      )}
      <Grid size="grow">
        <Typography {...typographyProps} variant={isSmallScreen ? "body2" : "body1"}>
          {!isSmallScreen && "Magasin de retrait : "}
          <Typography
            variant={isSmallScreen ? "body2" : "body1"}
            component="strong"
            color="primary">
            {magasinDeRetrait}
          </Typography>
        </Typography>
      </Grid>
    </Grid>
  );
}

export default DisplayMagasinDeRetrait;
